var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHwCloseFollowingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14353_4557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7798 15.7171C28.0657 15.4312 28.0751 14.9718 27.7985 14.6765L23.2985 9.80147C23.0173 9.49679 22.5438 9.47804 22.2392 9.75929C21.9345 10.0405 21.9157 10.514 22.197 10.8187L25.5392 14.4374H6.55947L9.77978 11.2171C10.0704 10.9265 10.0704 10.4483 9.77978 10.1577C9.48916 9.8671 9.01103 9.8671 8.72041 10.1577L4.22041 14.6577C3.92979 14.9483 3.92979 15.4265 4.22041 15.7171L8.72041 20.2171C9.01103 20.5077 9.48916 20.5077 9.77978 20.2171C10.0704 19.9265 10.0704 19.4483 9.77978 19.1577L6.55947 15.9374H25.436L22.2157 19.1577C21.9251 19.4483 21.9251 19.9265 22.2157 20.2171C22.5063 20.5077 22.9845 20.5077 23.2751 20.2171L27.7751 15.7171H27.7798Z",
    fill: "#18303E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_14353_4557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5 3C29.9125 3 30.25 3.3375 30.25 3.75V26.25C30.25 26.6625 29.9125 27 29.5 27C29.0875 27 28.75 26.6625 28.75 26.25V3.75C28.75 3.3375 29.0875 3 29.5 3Z",
    fill: "#18303E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_14353_4557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3C2.9125 3 3.25 3.3375 3.25 3.75V26.25C3.25 26.6625 2.9125 27 2.5 27C2.0875 27 1.75 26.6625 1.75 26.25V3.75C1.75 3.3375 2.0875 3 2.5 3Z",
    fill: "#18303E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14353_4557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_14353_4557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 24,
    fill: "white",
    transform: "translate(28 3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_14353_4557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 24,
    fill: "white",
    transform: "translate(1 3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHwCloseFollowingIcon);
export default __webpack_public_path__ + "static/media/hw_close_following_icon.f9537e87f1a9b152ff9088ac45554cfa.svg";
export { ForwardRef as ReactComponent };